import React from "react"
import { Common } from "lib/types"
import { ReactComponent as SettingsIcon } from "images/icons/gear.svg"
import { PermissionGroups } from "../constants"

import { Settings, UsagePlan, ExternalEvents, ApiClients } from "views/Settings"
import Credentials from "views/Settings/Credentials/Credentials"
import CreateApiDestination from "views/Settings/ExternalEvents/DestinationAPIs/CreateApiDestination"
import UpdateApiDestination from "views/Settings/ExternalEvents/DestinationAPIs/UpdateApiDestination"
import { ShowUsers } from "views/Users/ShowUsers"
import { User } from "views/Users/User"
import { Providers } from "views/Settings"
import {
  ShowProviders,
  AdyenConfiguration,
  KustomConfig,
  SveaConfiguration,
  IngridConfiguration,
  Retain24Config,
  NShiftConfiguration,
  VoyadoConfiguration,
  WalleyConfiguration,
  BonusConfiguration,
  ExternalPriceConfiguration,
  QliroOneConfiguration,
  AvardaConfiguration,
  ZaverConfiguration,
  LedyerConfiguration,
  CustomPaymentConfiguration,
  TaxJarConfiguration,
  CustomGiftCardConfiguration
} from "views/Settings/Providers"

export const settingsRoutes: Common.Views = [
  {
    element: <Settings />,
    path: "/settings",
    title: "Settings",
    icon: SettingsIcon,
    sortOrder: 7,
    children: [
      {
        element: <Providers />,
        path: "/settings/providers",
        title: "Providers",
        parentPath: "/settings",
        requiredGroups: PermissionGroups.providers.read,
        section: "Connections",
        children: [
          {
            element: <ShowProviders />,
            path: "/settings/providers",
            title: "Show Providers",
            parentPath: "/settings"
          },
          {
            element: <AdyenConfiguration />,
            path: "/settings/providers/adyen",
            title: "Adyen",
            parentPath: "/settings/providers"
          },
          {
            element: <KustomConfig />,
            path: "/settings/providers/kustom",
            title: "Kustom",
            parentPath: "settings/providers"
          },
          {
            element: <SveaConfiguration />,
            path: "/settings/providers/svea",
            title: "Svea",
            parentPath: "/settings/providers"
          },
          {
            element: <IngridConfiguration />,
            path: "/settings/providers/ingrid",
            title: "Ingrid",
            parentPath: "/settings/providers"
          },
          {
            element: <Retain24Config />,
            path: "/settings/providers/retain24",
            title: "Retain24",
            parentPath: "/settings/providers"
          },
          {
            element: <NShiftConfiguration />,
            path: "/settings/providers/Nshift",
            title: "nShift",
            parentPath: "/settings/providers"
          },
          {
            element: <VoyadoConfiguration />,
            path: "/settings/providers/voyado",
            title: "Voyado",
            parentPath: "/settings/providers"
          },
          {
            element: <WalleyConfiguration />,
            path: "/settings/providers/walley",
            title: "Walley",
            parentPath: "/settings/providers"
          },
          {
            element: <BonusConfiguration />,
            path: "/settings/providers/bonus",
            title: "Bonus providers",
            parentPath: "/settings/providers"
          },
          {
            element: <ExternalPriceConfiguration />,
            path: "/settings/providers/external-price",
            title: "External Price providers",
            parentPath: "/settings/providers"
          },
          {
            element: <QliroOneConfiguration />,
            path: "/settings/providers/qliro",
            title: "Qliro One",
            parentPath: "/settings/providers"
          },
          {
            element: <AvardaConfiguration />,
            path: "/settings/providers/avarda",
            title: "Avarda",
            parentPath: "/settings/providers"
          },
          {
            element: <ZaverConfiguration />,
            path: "/settings/providers/zaver",
            title: "Zaver",
            parentPath: "/settings/providers"
          },
          {
            element: <LedyerConfiguration />,
            path: "/settings/providers/ledyer",
            title: "Ledyer",
            parentPath: "/settings/providers"
          },
          {
            element: <CustomPaymentConfiguration />,
            path: "/settings/providers/custom-payment",
            title: "Custom Payment",
            parentPath: "/settings/providers"
          },
          {
            element: <TaxJarConfiguration />,
            path: "/settings/providers/tax-jar",
            title: "TaxJar",
            parentPath: "/settings/providers"
          },
          {
            element: <CustomGiftCardConfiguration />,
            path: "/settings/providers/bsg-gift-card",
            title: "Brink Custom Gift Card",
            parentPath: "/settings/providers"
          }
        ]
      }
    ]
  },
  {
    element: <ExternalEvents />,
    path: "/settings/external-events",
    parentPath: "/settings",
    title: "External events",
    requiredGroups: PermissionGroups.externalEvents.read
  },
  {
    element: <CreateApiDestination />,
    path: "/settings/external-events/create-api-destination",
    parentPath: "/settings/external-events",
    title: "Create API destination",
    requiredGroups: PermissionGroups.externalEvents.write
  },
  {
    element: <UpdateApiDestination />,
    path: "/settings/external-events/update-api-destination/:name",
    parentPath: "/settings/external-events",
    title: "Update API destination",
    requiredGroups: PermissionGroups.externalEvents.read
  },
  {
    element: <UsagePlan />,
    path: "/settings/usage-plan",
    parentPath: "/settings",
    title: "Usage plan",
    section: "Brink configurations",
    requiredGroups: PermissionGroups.system.read
  },
  {
    element: <Credentials />,
    path: "/settings/credentials",
    parentPath: "/settings",
    title: "Credentials",
    requiredGroups: PermissionGroups.system.read
  },
  {
    element: <ApiClients />,
    path: "/settings/api-configs",
    parentPath: "/settings",
    title: "API clients",
    requiredGroups: PermissionGroups.apiClients.read
  },
  {
    element: <ShowUsers />,
    path: "/settings/manage-users",
    parentPath: "/settings",
    title: "Manage users",
    section: "Users",
    requiredGroups: PermissionGroups.users.read
  },
  {
    element: <User />,
    path: "/user"
  }
]
